import React from 'react';

// Button styles matching the fact-find design language
// (see fact-find-test/FactFindTest.js primary/secondary buttons).
const VARIANT_CLASSES = {
    primary: 'rounded-xl px-5 py-2.5 text-sm font-semibold text-white shadow-md transition-transform active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed',
    secondary: 'rounded-xl border-2 bg-white px-5 py-2.5 text-sm font-semibold transition-colors hover:bg-[#F5F6FA] disabled:opacity-50 disabled:cursor-not-allowed',
    danger: 'rounded-xl px-5 py-2.5 text-sm font-semibold text-white shadow-md transition-transform active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed',
    ghost: 'rounded-xl px-3 py-2 text-sm font-semibold transition-colors hover:bg-[#EFEAFE] disabled:opacity-50 disabled:cursor-not-allowed',
};

const VARIANT_STYLES = {
    primary: { backgroundColor: '#7C5CFC' },
    secondary: { borderColor: '#D1D5DB', color: '#1F2937' },
    danger: { backgroundColor: '#DC2626' },
    ghost: { color: '#5B3FE0' },
};

const Button = ({ variant = 'primary', className = '', style, children, type = 'button', ...rest }) => (
    <button
        type={type}
        className={`inline-flex items-center justify-center gap-2 ${VARIANT_CLASSES[variant] || VARIANT_CLASSES.primary} ${className}`}
        style={{ ...(VARIANT_STYLES[variant] || VARIANT_STYLES.primary), ...style }}
        {...rest}
    >
        {children}
    </button>
);

export default Button;
